export const FLIGHT_DATE_TIME_ZONE = "America/Los_Angeles";

export const normalizeFlightDateOnly = (value) => {
  if (!value) return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const raw = String(value || "").trim();
  if (!raw) return null;

  const match = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return match[1];

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString().slice(0, 10);
};

export const parseFlightDateSafe = (value) => {
  const dateOnly = normalizeFlightDateOnly(value);
  if (!dateOnly) return null;
  const match = dateOnly.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const y = Number(match[1]);
  const mo = Number(match[2]) - 1;
  const d = Number(match[3]);
  const dt = new Date(y, mo, d);
  return Number.isNaN(dt.getTime()) ? null : dt;
};

const formatFlightDateLabel = (value, { includeYear = true } = {}) => {
  const dateOnly = normalizeFlightDateOnly(value);
  if (!dateOnly) return "—";

  const match = dateOnly.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return "—";

  const dt = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12));

  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: FLIGHT_DATE_TIME_ZONE,
      month: "short",
      day: "numeric",
      ...(includeYear ? { year: "numeric" } : {}),
    }).format(dt);
  } catch {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const yearLabel = includeYear ? `, ${match[1]}` : "";
    return `${months[Number(match[2]) - 1]} ${Number(match[3])}${yearLabel}`;
  }
};

export const formatFlightDateShort = (value) =>
  formatFlightDateLabel(value, { includeYear: false });

export const formatFlightDate = (value) =>
  formatFlightDateLabel(value, { includeYear: true });

export const formatFlightRange = (start, end) => {
  const a = formatFlightDate(start);
  const b = formatFlightDate(end);
  if (a === "—" && b === "—") return "—";
  return `${a} → ${b}`;
};
